function CertificationsActions() {
	return <div id="certifications-drawer" />;
}

export default CertificationsActions;
